import { Component } from '@verndale/core';
import { dispatchGenericEvent } from '../utils/dispatch-events';
import { constEvent } from '../utils/constants'

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $footerLnksTitle: this.el._$$('.footer-section-list__title'),
      $newsletter: this.el._$('.footer-newsletter'),
      $emailWrapper: this.el._$('.footer-newsletter__email'),
      $email: this.el._$('input[type="email"]'),
      $submit: this.el._$('.footer-newsletter__submit'),
      $error: this.el._$('.field__msg--error'),
      $eloquaModal: this.el._$('.eloqua-modal'),
      $confirmationModal: this.el._$('.confirmation-modal')
    };

    this.successClass = 'field-wrapper--success';
    this.errorClass = 'field-wrapper--error';
    this.expandedClass = 'footer-section-list__item--expanded';
    this.enableDisableSubmit();
  }

  addListeners() {
    this.dom.$footerLnksTitle._on('click', this.toggleDisplay.bind(this));
    this.dom.$newsletter._on('submit', this.onNewsletterSubmit.bind(this));
    this.dom.$newsletter._on('input', this.enableDisableSubmit.bind(this));
    this.dom.$eloquaModal._on(constEvent.CLOSED_ELOQUA_MODAL, this.onEloquaModalClose.bind(this));
    this.dom.$confirmationModal._on(constEvent.DENY_CONFIRMATION, this.onDenyCloseEloqua.bind(this));
  }

  toggleDisplay(e) {
    const $parent = e.target.closest('.footer-section-list__item');

    if ($parent.classList.contains(this.expandedClass)) {
      $parent.classList.remove(this.expandedClass);
    } else {
      $parent.classList.add(this.expandedClass);
    }
  }

  enableDisableSubmit() {
    this.dom.$submit.disabled = this.dom.$email.value ? false : true;
  }

  onNewsletterSubmit(e) {
    e.preventDefault();
    const email = this.dom.$email.value;
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValid = email === '' || regex.test(String(email).toLowerCase());

    if (!isValid) {
      this.dom.$emailWrapper.classList.add(this.errorClass);
      this.dom.$emailWrapper.classList.remove(this.successClass);
      this.dom.$error.html = `<small>${this.dom.$email.dataset.errorEmail}</small>`
      return;
    }

    this.dom.$emailWrapper.classList.add(this.successClass);
    this.dom.$emailWrapper.classList.remove(this.errorClass);
    dispatchGenericEvent(constEvent.OPEN_ELOQUA_MODAL, null, document.getElementById(this.el.dataset.eloquaModalId));
  }

  onEloquaModalClose() {
    dispatchGenericEvent(constEvent.OPEN_CONFIRMATION_MODAL, {}, this.dom.$confirmationModal);
  }

  onDenyCloseEloqua() {
    dispatchGenericEvent(constEvent.OPEN_ELOQUA_MODAL, {}, this.dom.$eloquaModal);
  }
}

export default Module;
